import type { FoundingCityLoctician } from '../types/hubs';

export const FOUNDING_CITY_PREVIEW_NAME = '创始城市预览';

export const FOUNDING_CITY_LOCTICIANS: FoundingCityLoctician[] = [
  {
    id: 'nia-preview',
    name: 'Nia',
    studioLabel: '独立编发师',
    neighborhood: '西区',
    serviceArea: '社区工作室 · 地址私信告知',
    specialties: ['初始编发', '修复', '日常维护'],
    consultationModes: ['到店', '视频'],
    portfolioHighlights: ['初始编发方案', '修复细节', '健康维护'],
    responseNote: '通常在一个工作日内回复',
    identityStatus: 'preview',
    decoratedMarker: true,
    location: { lat: 33.7351, lng: -84.4136 },
  },
  {
    id: 'maya-preview',
    name: 'Maya',
    studioLabel: '上门编发师',
    neighborhood: '老第四区',
    serviceArea: '可在城市大范围上门服务',
    specialties: ['日常维护', '造型', '咨询'],
    consultationModes: ['到店', '视频'],
    portfolioHighlights: ['重绞完成效果', '活动造型', '护理咨询'],
    responseNote: '预约名额每周浮动，请提前联系',
    identityStatus: 'preview',
    decoratedMarker: false,
    location: { lat: 33.7668, lng: -84.3717 },
  },
  {
    id: 'jordan-preview',
    name: 'Jordan',
    studioLabel: '工作室编发师',
    neighborhood: '东角',
    serviceArea: '出于隐私仅显示大致区域',
    specialties: ['初始编发', '染色', '造型'],
    consultationModes: ['到店'],
    portfolioHighlights: ['线圈初始效果', '染色方案', '编辑造型'],
    responseNote: '新客咨询名额每月开放',
    identityStatus: 'preview',
    decoratedMarker: false,
    location: { lat: 33.6796, lng: -84.4394 },
  },
];

export const FOUNDING_CITY_SPECIALTY_OPTIONS = [
  '全部需求',
  ...Array.from(new Set(FOUNDING_CITY_LOCTICIANS.flatMap((loctician) => loctician.specialties))),
];
